import { render, staticRenderFns } from "./SharedFolder.vue?vue&type=template&id=37166548&"
import script from "./SharedFolder.vue?vue&type=script&lang=js&"
export * from "./SharedFolder.vue?vue&type=script&lang=js&"
import style0 from "./SharedFolder.vue?vue&type=style&index=0&id=37166548&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports